import Button from 'components/generic-components/thera-start-components/Button';
import { GoArrowLeft } from 'react-icons/go';
import { FaCheck } from 'react-icons/fa';
import { getSelectedState } from 'lib/theraStartConstants';

export default function FasterFilingStep({ formik, onNext, onBack }) {
  const state = formik?.values?.state;
  const selectedState = getSelectedState(state);

  return (
    <div className="relative flex flex-col items-center justify-center bg-[#181818] px-4 py-8">
      {/* Back Button - top-right corner of screen */}
      <div className="max-w-1xl mb-4 w-full">
        <button
          type="button"
          onClick={onBack}
          className="mb-2 flex items-center gap-2 font-semibold text-white transition-colors hover:text-blue-500"
        >
          <GoArrowLeft size={18} />
          <span>Back</span>
        </button>
      </div>

      {/* Card */}
      <div className="max-w-1xl relative mx-auto w-full rounded-2xl bg-white p-6 shadow-xl sm:p-8 md:p-10">
        <h2 className="mb-1 text-[1.5rem] font-[600] text-dark">File your DBA (Trade Name)</h2>
        <div className="mb-1 flex items-center justify-between">
          <span className="mt-5 text-[1.15rem] font-bold text-dark">{selectedState?.State} DBA Services</span>
          <span className="text-[1.15rem] font-[500] text-[#2571CF]">${selectedState?.TotalDBAFees || 0}</span>
        </div>
        <div className="mb-2 text-[1rem] text-dark">One time</div>
        <hr className="mb-4" />

        <div className="mb-4">
          <div className="mb-2 text-[0.9rem] font-[400] text-[#000000]">WHAT TO KNOW</div>
          <ul className="mb-4">
            <li className="mb-[1rem] flex items-start font-sans text-[1rem]">
              <span className="mr-[1rem] flex size-5 shrink-0 items-center justify-center rounded-full bg-[#F2F2F2] pb-[0.25rem]">
                <FaCheck className="mt-1 size-3 text-dark" />
              </span>
              <span className="text-[#191919CC]">
                They'll offer advice as needed, complete and file your federal registration application, keep track of
                deadlines, and respond to procedural office actions.
              </span>
            </li>
          </ul>
        </div>

        <Button
          className="mb-2 w-full rounded-lg !bg-black py-3 text-[1rem] font-semibold !text-white transition-colors hover:!bg-gray-900"
          onClick={() => {
            formik.setFieldValue('fasterFiling', true);
            onNext();
          }}
        >
          Add Trade Name Filing
        </Button>

        <Button
          variant="white"
          className="w-full rounded-lg border border-black bg-white py-3 text-[1rem] font-semibold text-black transition-colors hover:bg-gray-100"
          onClick={() => {
            formik.setFieldValue('fasterFiling', false);
            onNext();
          }}
        >
          Skip
        </Button>
      </div>
    </div>
  );
}
